/** Physical store details — single source for footer + mobile menu. */
export const STORE_INFO = {
  addressLine1: 'Community 18, Spintex',
  addressLine2: 'Adjacent KFC, Accra',
  phone: '0594 701 345',
  hours: 'Mon–Sat · 9am – 8pm',
} as const;
